import React from "react";
import CustomSelect from "../../../../Base/CustomSelect";
import BarChart from "./BarChart";
const timeframe = [
  {
    value: "Dayly",
  },
  {
    value: "Weekly",
  },
  {
    value: "Monthly",
  },
];
const labels = ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul"];
export default function ChartOuter() {
  return (
    <div className="chart box">
      <div className="chart__head">
        <div className="chart__head-row">
          <h4 className="big">Payment requests</h4>
          <CustomSelect list={timeframe} selected={timeframe[0]} />
        </div>
        <div className="chart__head-price">$8,527,224</div>
      </div>
      <div className="chart__body">
        <BarChart
          labels={labels}
          data={[6000, 2000, 5500, 7000, 4000, 8000, 5200]}
        />
      </div>
    </div>
  );
}
